/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import JSG from '@cedalo/jsg-ui';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../helper/IntlGlobalProvider';
import { useJSGNotification } from '../../utils/JSGHooks';
import {Divider} from '@mui/material';
import DialogButton from '../../utils/DialogButton';
import { getParserErrorMessage } from '../../../languages/translations';

export default function AlertDialog() {
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState('None');
	const [id, setId] = useState(undefined);
	const [messageObject, setMessageObject] = useState();

	const onSheetMessage = (notification) => {
		if (notification.object) {
			const { message: info } = notification.object;
			try {
				setId(info.id);
				setMessage(info.message);
				setOpen(true);
				setMessageObject(info);
			} catch(e) {
				console.log(e);
			}
		}
	};

	useJSGNotification(JSG.WorksheetView.SHEET_MESSAGE_NOTIFICATION, onSheetMessage);

	const handleClose = () => {
		setOpen(false);
		if (messageObject.focusElement) {
			messageObject.focusElement._ignoreBlur = true;
			const start = messageObject.start || messageObject.focusIndex;
			const cellEditor = JSG.CellEditor.getActiveCellEditor();
			if (cellEditor) {
				cellEditor.restoreSelection({ start, end: start }, messageObject.focusElement);
			}
			messageObject.focusElement._ignoreBlur = false;
		}
	};

	let dlgMessage = message;
	if (id) dlgMessage = intl.formatMessage({ id });
	else if (messageObject && messageObject.code) {
		const error = getParserErrorMessage(messageObject);
		dlgMessage = intl.formatMessage(error, error);
	}
	
	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>
					<FormattedMessage id="DialogAlert.Title" defaultMessage="Alert" />
				</DialogTitle>
				<DialogContent
					style={{
						margin: '20px'
					}}
				>
					<DialogContentText>{dlgMessage}</DialogContentText>
				</DialogContent>
				<Divider />
				<DialogActions>
					<DialogButton id="okalert" defaultButton margin onClick={handleClose}>
						<FormattedMessage id="Dialog.OK" defaultMessage="OK" />
					</DialogButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
